import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { CLINIC } from "@/lib/content";

export default function WhatsAppFloat() {
    const whatsappHref = `https://wa.me/${CLINIC.whatsapp}?text=${encodeURIComponent(
        "Hello Galaxy Dental Clinic, I'd like to book an appointment.",
    )}`;
    const callHref = `tel:${CLINIC.phoneRaw}`;

    return (
        <div
            data-testid="float-cta-group"
            className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3"
        >
            {/* Call button */}
            <a
                href={callHref}
                data-testid="call-float-button"
                aria-label={`Call ${CLINIC.phone}`}
                className="group relative flex items-center gap-2 rounded-full bg-[#114b5f] text-[#faf9f6] pl-4 pr-5 py-3 shadow-xl hover:shadow-2xl hover:bg-[#0d3a4a] transition-all hover:-translate-y-0.5"
            >
                <span className="absolute inset-0 rounded-full bg-[#114b5f]/30 animate-ping opacity-70" />
                <Phone
                    size={18}
                    strokeWidth={2}
                    className="relative"
                />
                <span className="relative text-sm font-medium tracking-wide">
                    Call now
                </span>
            </a>

            {/* WhatsApp button */}
            <a
                href={whatsappHref}
                target="_blank"
                rel="noreferrer"
                data-testid="whatsapp-float-button"
                aria-label="Chat with us on WhatsApp"
                className="group relative"
            >
                <span className="absolute inset-0 rounded-full bg-[#25D366]/40 animate-ping" />
                <span className="relative flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-xl hover:shadow-2xl transition-all hover:-translate-y-0.5">
                    <MessageCircle size={18} strokeWidth={2} />
                    <span className="text-sm font-medium tracking-wide">
                        WhatsApp
                    </span>
                </span>
            </a>
        </div>
    );
}
